import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SoftBadge = ({ bg = 'primary', pill, children, className, style, ...rest }) => {
    return (
        <>
            {
                bg == 'stripe' ?
                    <>
                        <div
                            className={classNames(className, `badge`, {
                                'rounded-pill': pill
                            })}
                            style={{ backgroundColor: '#625bff', ...style }}
                            {...rest}
                        >
                            {children}
                        </div>
                    </>
                    :
                    <>
                        <div
                            className={classNames(className, `badge badge-soft-${bg}`, {
                                'rounded-pill': pill
                            })}
                            style={style}
                            {...rest}
                        >
                            {children}
                        </div>
                    </>
            }
        </>

    );
};

SoftBadge.propTypes = {
    bg: PropTypes.oneOf([
        'primary',
        'secondary',
        'success',
        'info',
        'warning',
        'danger',
        'light',
        'stripe',
        'dark'
    ]),
    pill: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object
};

export default SoftBadge;
